import DabblAudience from './components/DabblAudience.js';
import connect from './connect';
import './assets/DabblAudience.css';
import 'chartist/dist/chartist.min.css'

export default connect(DabblAudience);



// WEBPACK FOOTER //
// ./src/routes/DabblAudience/index.js